<template>
<div class="aboutus">
  <el-container>
    <el-header id="top">
        <div class="container nav"
         v-bind:class="{ 'navActive': scrollFlag }">
          
          <el-menu
            :default-active="activeaboutus"
            class="el-menu-demo"
            mode="horizontal"
           
            @select="handleSelect"
           
            >
            <div class="logo"><img src="../assets/logo.png" ></div>
            <el-menu-item index="6" class="hr" @click="toRecruit">诚聘英才</el-menu-item>
            <el-menu-item index="5" @click="toBg6">联系我们</el-menu-item>
            <el-menu-item index="4" @click="toBg5">软件著作权</el-menu-item>
            <el-menu-item index="3" @click="toBg4">合作伙伴</el-menu-item>
            <el-menu-item index="2" @click="toBg3">业务介绍</el-menu-item>
            <el-menu-item index="1" @click="goIndex">首页</el-menu-item>
            
          </el-menu>
        </div>
        <div class="scrollbg" v-if="scrollFlag"></div>
        <div class="container bg1txt">
          <div class="bg1txtl">关于我们</div>
          <div  class="bg1txts"><span class="bg1line"></span> ABOUT US <span class="bg1line"></span></div>

            
        </div>
    </el-header>
    <div class="container bg2">
      <div class="bg2main">
        <div class="bg2title">
          镒 &nbsp;道
        </div>
        <div class="bg2titles">
          YIDAO
        </div>
        <div>
          <div class="bg2con">
            <span class="point"></span>
              <span class="weight">上海镒道网络科技有限公司</span>位于上海市浦东新区，是一家面向金融行业提供技术服务的高科技企业，定位服务于中国银联、商业银行、支付机构及其它金融机构。            
          </div>
          <div class="bg2con">
            <span class="point"></span>
              凭借<span class="weight">专业的行业经验，过硬的技术实力，诚信的服务理念</span>,公司向金融行业从业机构提供专业化的产品、服务和行业解决方案，赢得了诸多合作机构的一致认可，并与这些合作机构建立了良好的合作关系。
          </div>
          <div class="bg2con">
            <span class="point"></span>
              企业的竞争力最终都要通过人来体现。上海镒道网络科技有限公司有一整套包括研发、测试、产品、运营、市场在内的稳定的专业团队，各部门分工明确、目标一致，有能力高效地、负责任地处理从系统研发到系统运营中遇到的各类问题。           
          </div>
          <div class="bg2con">
            <span class="point"></span>
              公司现在职员工50人左右，<span class="weight">100%具有国内重点大学本科或以上学历</span>，团队成员拥有丰富的金融科技行业业务经验，大部分曾服务于中国银联，商业银行或第三方支付机构，均为业内相关领域资深专家。           
          </div>
        </div>
      </div>
    </div>
    <div class="container bg3">
      <div class="bg3title">
      </div>
    </div>
    <div class="bg3ground"></div>
    <div class="container bg4">
      <div class="bg4con" >
        <div class="bg4main">
          <div class="bg4contitle"><span class="star"></span>高新技术企业认证</div>
          <div class="bg4line"></div>
          <div class="bg4contxt">
            「高新技术企业」是在国家重点支持的高新技术领域内，持续进行研究开发与技术成果转化，形成企业核心自主知识产权，并以此为基础开展生产经营活动，在中国境内（不包括港、澳、台地区）注册一年以上的居民企业。
            高新技术企业的认定，将有效地提高企业的科技研发管理水平，重视科技研发，提高企业核心竞争力
          </div>
        </div>
      </div>
      <div class="bg4con" >
        <div class="bg4main">
          <div class="bg4contitle"><span class="star"></span>双软认证</div>
          <div class="bg4line"></div>
          <div class="bg4contxt">
            「双软认证」是指软件产品评估和软件企业评估；企业申请双软认证除了获得软件企业和软件产品的认证资质，同时也是对企业知识产权的一种保护方式，更可以让企业享受国家提供给软件行业的税收优惠政策。
            主要意义：作为税收减免的重要依据，作为法律重点保护的依据，作为技术出资入股，作为申请科技成果的依据。
          </div>
        </div>
      </div>
      <div class="bg4con" >
        <div class="bg4main">
          <div class="bg4contitle"><span class="star"></span>软件著作权及专利</div>
          <div class="bg4line"></div>
          <div class="bg4contxt">
            「公司目前拥有软件著作权39项，实用新型专利7项，发明专利1项。总知识产权数52项。
            主要系统如下： 对账系统、交易系统、清算系统、销账系统、支付管理系统、代付系统、代收系统、风控系统、交易计费系统、短信信息系统、交易流水系统、内容转接系统、数据服务系统、数据迁移系统、用户信息系统等。
          </div>
        </div>
      </div>
    </div>
    <div class="container bg5">
      <div class="bg5title"></div>
      <div class="bg5main">
        <el-row>
          <div class="bg5top1">
            <div class="main">
              <div class="bg5toptitle">
                行业经验
              </div>
              <div class="bg5toptxt">
                一直服务于中国银联、支付机构、商业银行等诸多机构，积累了大量地行业经验，对于客户需求及市场需求有着充分的认识和理解，对于如何高效地解决处理问题有着独到的认知和方法。
              </div>
            </div>
          </div>
          <div class="bg5top2">
            <div class="main">
              <div class="bg5toptitle">
                产品能力
              </div>
              <div class="bg5toptxt">
                长期专注于支付、资金、数据业务综合解决方案，在业内有着较高的权威及地位。有着敏锐的市场洞察能力，能够第一时间了解市场需求及客户需求，并迅速响应，依靠丰富的行业经验，制定出一套在合情、合理、合规的前提下解决问题，满足业务需求的解决方案。
              </div>
            </div>
          </div>
          <div class="bg5top3">
            <div class="main">
              <div class="bg5toptitle">
                技术能力
              </div>
              <div class="bg5toptxt">
                团队主持过中国银联、商业银行、支付机构等合作方的核心业务系统建设，对于大并发、高负载类金融系统的建设有着丰富的经验，有着一整套专业的、合适的研发测试理论和标准，至今尚未出现由于系统缺陷或bug导致的生产事故。
              </div>
            </div>
          </div>

        </el-row>
        <el-row>
            <div class="bg5bottom1">
              <div class="main">
                <div class="bg5toptitle bottomtitle">
                  市场能力
                </div>
                <div class="bg5toptxt">
                    与众多支付机构及商业银行都有着非常紧密的合作关系，新产品、新平台的推出能够迅速得到客户的响应。
在遇到生产事故或其他突发情况时，能够第一时间和客户沟通，并做好维稳工作，以保证业务能持续开展。
                </div>
              </div>
            </div>
            <div class="bg5bottom2">
              <div class="main">
                <div class="bg5toptitle bottomtitle">
                  市场能力
                </div>
                <div class="bg5toptxt">
                    与众多支付机构及商业银行都有着非常紧密的合作关系，新产品、新平台的推出能够迅速得到客户的响应。
在遇到生产事故或其他突发情况时，能够第一时间和客户沟通，并做好维稳工作，以保证业务能持续开展。
                </div>
              </div>
            </div>
        </el-row>
      </div>
    </div>
    <el-footer class="footer">
        <div class="container">
            <div class="nav">
              <div class="navcon" @click="goIndex">首页</div>
              <div class="navline"></div>
              <div class="navcon" @click="toBg3">业务介绍</div>
              <div class="navline"></div>
              <div class="navcon" @click="toBg4">合作伙伴</div>
              <div class="navline"></div>
              <div class="navcon long" @click="toBg5">软件著作权</div>
              <div class="navline"></div>
              <div class="navcon" @click="toBg6">联系我们</div>
              <div class="navline"></div>
              <div class="navcon" @click="toRecruit">诚聘英才</div>
              
            </div>
            <div class="copyright">
              <div class="left">
                <div class="title1">上海镒道网络科技有限公司 (c)</div>
                <div class="title2" @click="gobeian">2024 All Rights Reserved 沪ICP备2024076183号-1</div>
                <div class="title2" @click="gonganGobeian">沪公网安备31011502401276</div>
              </div>
              <div class="right">
                <div class="logo"><img src="../assets/logo.png" ></div>
              </div>
              
            </div>
          </div>  
      </el-footer>
  </el-container>
</div>
</template>

<script>

export default {
  name: 'HelloWorld',
  data () {
    return {
      activeaboutus: '',
      scrollFlag:false,
      

    }
  },
  methods: {
    toRecruit(){
        this.$router.push('/recruit')
      },
      gobeian(){
        window.location.href = 'https://beian.miit.gov.cn/';
      },
      gonganGobeian(){
        window.location.href = 'https://beian.mps.gov.cn/#/query/webSearch?code=31011502401276';
      },
      goIndex(){
        sessionStorage.setItem('nav','index')
        this.$router.push('/')
      },
      goAboutUs(){
        this.$router.push('/aboutus')
      },
      toTop(e){
        document.getElementById("top").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
      toBg3(){
         sessionStorage.setItem('nav','Bg3')
         this.$router.push('/')
      },
      toBg4(){
        sessionStorage.setItem('nav','Bg4')
         this.$router.push('/')
      },
      toBg5(){
        sessionStorage.setItem('nav','Bg5')
         this.$router.push('/')
      },
      toBg6(){
        sessionStorage.setItem('nav','Bg6')
         this.$router.push('/')
      },
      handleSelect(key, keyPath) {
        
      },
      handleScroll () {
        let _this=this;
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // console.log(scrollTop)
        if(scrollTop){
          _this.scrollFlag=true
        }else{
          _this.scrollFlag=false
        }
      },
      
      
  },
  mounted(){
    window.addEventListener('scroll', this.handleScroll)
  }
} 

</script>
<style scoped>
.aboutus .footer{
  width: 100%;
  margin-top: 90px;
  height: 330px!important;
  background-image: url("../assets/bg_06.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 0;

}
.aboutus .footer .copyright{
  margin-top: 30px;
  overflow: hidden;

}
.aboutus .footer .copyright .left{
  float: left;
  text-align: left;
}
.aboutus .footer .copyright .left .title1{
  font-family: PingFangSC-Semibold;
font-size: 14px;
color: #FFFFFF;
font-weight: 600;
}
.aboutus .footer .copyright .left .title2{
font-family: PingFangSC-Regular;
font-size: 14px;
color: #848991;
margin-top: 4px;
cursor: pointer;
}
.aboutus .footer .copyright .right{
  float: right;
  margin-top: -6px;
}
.aboutus .footer .nav{
  margin-top: 110px;
}
.aboutus .footer .navcon{
  font-family: PingFangSC-Regular;
font-size: 16px;
color: #FFFFFF;
text-align: center;
float: left;
width: 94px;
cursor: pointer;
}
.aboutus .footer .navcon.long{
width: 109px;
}
.aboutus .footer .navcon:hover{
  opacity: 0.5;
  color:#fff
}
.aboutus .footer .navcon:first-child{
text-align: left;
width: 50px;
}

.aboutus .footer .navline{
  width: 1px;
  height: 16px;
  display: block;
  float: left;
  background: #DBBA66;
  margin-top: 3.5px;
}
.aboutus>>>.el-carousel{
  
}

.aboutus>>>.el-carousel__button{
width: 40px;
height: 6px;
background: #F1F1F1;
opacity: 1;
cursor: pointer;
}
.aboutus>>>.el-carousel__indicator.is-active button{
  background: #DBBA66;
}
.aboutus>>>.el-carousel__mask{
  background-color: transparent;
  opacity: 0;
}
 .carousel-img {
    max-width: 100%;
    max-height: 100%;
  }

  
  .el-carousel__item:nth-child(2n) {
   
  }
  
  .el-carousel__item:nth-child(2n+1) {
    
  }
.aboutus{
 height: 100%;
}
.aboutus .el-fade-in-linear-leave-active{
  transition: opacity .5s linear;
  -webkit-transition: opacity .5s linear;
}
.aboutus .el-fade-in-linear-enter-active{
transition: opacity .5s linear;
  -webkit-transition: opacity .5s linear;
}
.aboutus .scrollbg{
  height: 80px;
}
.aboutus .el-main{
  padding: 0;
    margin-top: -140px;

}

.aboutus .logo{
  display: block;
  float: left;
  width: 200px;
  height: 60px;
  
 
}
.aboutus .nav{
  width: 100%!important;
  height: 80px;
  background: rgba(11,21,37,0.80);
  overflow: hidden;
}

.aboutus .logo img{
  width: 200px;
  height: 60px;
}
.aboutus .el-header{
  height: 480px!important;
  width: 100%;
  line-height: 80px;
  background-image: url("../assets/bg_top.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 0;
  padding: 0;
  
  position: relative;
}

.aboutus .container{
  width: 1080px;
  margin: 0 auto;
  position: relative;
}
.aboutus .bg2{
  height: 560px;
  width: 1140px;
  position: relative;
background-image: url("../assets/bg_about_us.png");
background-repeat: no-repeat;
background-position: 50% 0;
background-size: cover;
margin-top: -150px;
}
.aboutus .bg2 .bg2main{
  padding: 0 100px;
}
.aboutus .bg2 .bg2title{
  font-family: AlibabaPuHuiTiB;
font-size: 42px;
color: #333333;
letter-spacing: 0;
text-align: center;
margin-top: 80px;
font-weight: 600;
}
.aboutus .bg2 .bg2titles{
  font-family: AlibabaPuHuiTiM;
font-size: 22px;
color: #E5C27E;
letter-spacing: 1px;
text-align: center;
font-weight: 600;
}
.aboutus .bg2 .bg2con{
  font-family: PingFangSC-Regular;
font-size: 16px;
color: #151515;
text-align: justify;
line-height: 28px;
margin-top: 10px;
}
.aboutus .bg2 .bg2con .weight{
  font-weight: 600;
}
.aboutus .bg2 .bg2con:first-of-type{
margin-top: 20px;
}
.aboutus .bg2 .bg2con .point{
  background: #E5C27E;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
  margin-bottom: 3px;
}

.aboutus .bg3{
  margin-top: 80px;
  height: 50px;
}
.aboutus .bg3title{
 background-image: url("../assets/title_about_us_01.png");
 background-repeat: no-repeat;
 background-position: 50% 0;
 width: 100%;
  height: 50px;
  background-size: cover;
}
.aboutus .bg3title img{
  
}
.aboutus .bg3ground{
  width: 100%;
  
    height: 240px;
    background: #F7F7F7;
    margin-top: 75px;
}

.aboutus .bg4{
margin-top: -280px;
height: 340px;
}
.aboutus .bg4 .bg4con{
  background: #FFFFFF;
box-shadow: 0 0 10px 0 rgba(0,0,0,0.10), 0 0 30px 0 rgba(0,0,0,0.10);
border-radius: 4px;
border-radius: 4px;
float: left;
width: 320px;
height: 320px;
margin-right: 60px;
}
.aboutus .bg4 .bg4con:last-child{
  margin-right: 0;
}
.aboutus .bg4 .bg4con .bg4contitle{
  font-family: PingFangSC-Semibold;
font-size: 18px;
color: #333333;
font-weight: 600;
text-align: left;
margin-top: 40px;
}
.aboutus .bg4 .bg4con .bg4line{
width: 100%;
height: 1px;
background: #eee;
margin: 15px 0;
}
.aboutus .bg4 .bg4con .bg4contxt{
  font-family: PingFangSC-Regular;
font-size: 14px;
color: #333333;
text-align: justify;
}
.aboutus .bg4 .bg4con .bg4contitle .title{
  display:inline-block;
}
.aboutus .bg4 .bg4con .bg4contitle .star{
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url("../assets/star.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 3px;
  margin-right: 5px;
  
}
.aboutus .bg4 .bg4con .bg4contitle img{

  
}
.aboutus .bg4 .bg4main{
  padding: 0 40px;
}
.aboutus .bg5{
  margin-top: 95px;
  overflow: hidden;
}
.aboutus .bg5 .main{
  padding: 0 49px;
}
.aboutus .bg5 .bg5toptitle{
  margin-top: 90px;
  font-family: PingFangSC-Semibold;
font-size: 22px;
color: #FFFFFF;
text-align: left;
font-weight: 600;
}
.aboutus .bg5 .bottomtitle{
margin-top: 120px;
}
.aboutus .bg5 .bg5toptxt{
  font-family: PingFangSC-Regular;
font-size: 14px;
color: #FFFFFF;
text-align: justify;
margin-top: 10px;
}
.aboutus .bg5title{
 background-image: url("../assets/title_about_us_02.png");
 background-repeat: no-repeat;
 background-position: 50% 0;
 width: 100%;
  height: 50px;
  background-size: cover;
}
.aboutus .bg5main{
  height: 620px;
  margin-top: 35px;
}
.aboutus .bg5main .bg5top1{
  width: 354px;
  height: 295px;
  background-image: url("../assets/software_copyright_01.png");
 background-repeat: no-repeat;
 background-position: 50% 0;
 background-size: cover;
 float: left;
 margin-right: 9px;
 }
 .aboutus .bg5main .bg5top2{
  width: 354px;
  height: 295px;
  background-image: url("../assets/software_copyright_02.png");
 background-repeat: no-repeat;
 background-position: 50% 0;
 background-size: cover;
 float: left;
 margin-right: 9px;
 }
  .aboutus .bg5main .bg5top3{
  width: 354px;
  height: 295px;
  background-image: url("../assets/software_copyright_03.png");
 background-repeat: no-repeat;
 background-position: 50% 0;
 background-size: cover;
 float: right;
 }
 .aboutus .bg5main .bg5bottom1{
   width: 535px;
  height: 295px;
  background-image: url("../assets/software_copyright_04.png");
 background-repeat: no-repeat;
 background-position: 50% 0;
 background-size: cover;
 float: left;
 margin-top: 10px;
 margin-right: 10px;

 }
 .aboutus .bg5main .bg5bottom2{
   width: 535px;
  height: 295px;
  background-image: url("../assets/software_copyright_05.png");
 background-repeat: no-repeat;
 background-position: 50% 0;
 background-size: cover;
 float: left;
 margin-top: 10px;
 

 }
.aboutus .bg6{
  margin-top: -120px;
}
.aboutus .bg7{
  height: 250px;
  margin-top: -130px;
}
.aboutus .bg7con{
  background: #FFFFFF;
box-shadow: 0 0 10px 0 rgba(0,0,0,0.10), 0 0 30px 0 rgba(0,0,0,0.10);
border-radius: 4px;
border-radius: 4px;
width: 180px;
height: 200px;
padding: 0 30px;
overflow: hidden;
margin-right: 40px;
float: left;

}
.aboutus .bg7con:last-child{
  margin-right: 0;
}
.aboutus .bg7con img{
  max-width: 100%;
  max-height: 100%;
}
.aboutus .bg7con .bg7logo{
  width: 80px;
  height: 80px;
  margin: 0 auto;
  margin-top: 20px;
}
.aboutus .bg7con .bg7title{
  margin-top: 3px;
  font-family: PingFangSC-Semibold;
font-size: 16px;
color: #333333;
text-align: center;
font-weight: 600;
}
.aboutus .bg7con .bg7txt{
  font-family: PingFangSC-Light;
font-size: 13px;
color: #333333;
text-align: center;
margin-top: 6px;
font-weight: 400;
}
.aboutus .bg6 .bg6title{
  font-family: SourceHanSerifCN-Heavy;
font-size: 30px;
color: #333333;
letter-spacing: 3px;
text-align: center;
font-weight: 600;
}



.aboutus .bg1txt{
  margin-top: 70px;
  display: block;
  overflow: hidden;
}
.aboutus .bg1txt .bg1txtl{
  font-family: SourceHanSerifCN-Heavy;
font-size: 50px;
color: #FFFFFF;
letter-spacing: 3px;
text-align: center;
font-weight: 600;
}
.aboutus .bg1txt .bg1txts{
font-family: TimesNewRomanPS-BoldMT;
font-size: 28px;
color: #FFFFFF;
letter-spacing: 3px;
text-align: center;
margin-top: -20px;
}
.aboutus .bg1txt .bg1txts .bg1line{
width: 17px;
height: 1px;
background-color: #fff;
display: inline-block;
margin-bottom: 8px;
}
.aboutus .bg1txt .button{
  width: 220px;
  height: 60px;
  margin-top: 46px;
  background-image: url("../assets/button.png");
  background-repeat: no-repeat;
  background-size: cover;
  font-family: PingFangSC-Medium;
font-size: 20px;
color: #08192F;
text-align: left;
line-height: 58px;
cursor: pointer;
}
.aboutus .el-menu.el-menu--horizontal{
  border-bottom:none;
  background:transparent;
  width: 1080px;
  margin: 10px auto;
}
.aboutus .el-menu--horizontal>.el-menu-item{
  font-family: PingFangSC-Regular;
font-size: 16px;
color: #FFFFFF;
text-align: center;
padding: 0 15px;
float: right;
}
.aboutus .hr{
  border: 1px solid #FFFFFF!important;
border-radius: 4px;
border-radius: 4px;
width: 100px;
height: 40px;
line-height: 40px;
margin-top: 9px;
margin-left: 12px;


}
.aboutus .el-menu--horizontal>.el-menu-item:hover{
  background-color: transparent;
  opacity: 0.5;
  color:#fff
}
.aboutus .el-menu--horizontal>.el-menu-item.is-active{
  color: #fff;
  background-color: transparent;
  border-bottom: 1px solid #DBBA66;
}
.aboutus .navActive{
position: fixed;
top: 0;
    background: rgba(11,21,37,0.80);
   
z-index: 100;
height: 80px;

}
</style>


// WEBPACK FOOTER //
// src/components/aboutus.vue